import React from 'react';
import './Section_9.css';
import { DynamicIcon } from 'lucide-react/dynamic';

function Footer({ footerConfig }) {
  if (!footerConfig) return null;

  const backgroundStyle = getBackground(footerConfig.bg_color);

  const getLucideIcon = (iconName, size =35) => {
             if (!iconName) return null;
             return <DynamicIcon name={iconName} size={size} />;
           };

  return (
    <footer className="footer" style={{ background: backgroundStyle }}>
  <div className="footer-content">
    <div className="footer-column">
      <h2 className="footer-logo">{footerConfig.logo}</h2>
      <p>{footerConfig.description}</p>
      <div className="social-icons">
        {footerConfig.social_icons.map((icon, idx) => (
          <a key={idx} href={icon.url} target="_blank" rel="noopener noreferrer">
            <i className={`fab fa-${icon.name}`}></i>
          </a>
        ))}
      </div>
    </div>

    <div className="footer-column">
  <h3>Contact Us</h3>
  <div className="footer-contact-row">
    <div className="sec9-item-icon">{getLucideIcon("map-pin-house")}</div>
    <strong className="footer-label">Address:</strong>
    <span className="footer-value">{footerConfig.contact.address}</span>
  </div>
  <div className="footer-contact-row">
    <div className="sec9-item-icon">{getLucideIcon("phone")}</div>
    <strong className="footer-label">Mobile:</strong>
    <span className="footer-value">{footerConfig.contact.mobile}</span>
  </div>
  <div className="footer-contact-row">
    <div className="sec9-item-icon">{getLucideIcon("mail")}</div>
    <strong className="footer-label">Email:</strong>
    <span className="footer-value">{footerConfig.contact.email}</span>
  </div>
</div>


    <div className="footer-column">
      <h3>Quick Links</h3>
      <ul>
        {footerConfig.quickLinks.map((link, idx) => (
          <li key={idx}>
            <a href={link.path}>{link.name}</a>
          </li>
        ))}
      </ul>
    </div>
  </div>

  {/* Bottom Bar */}
  {/* <div className="footer-bottom">
    <p>© 2025 Abhang. All rights reserved.</p>
    <p>Developed by Pratap Abhang</p>
  </div> */}
</footer>

  );
}

function getBackground(bgColors) {
  if (!bgColors || bgColors.length === 0) return "#333"; // fallback
  return bgColors.length === 1
    ? bgColors[0]
    : `linear-gradient(90deg, ${bgColors.join(", ")})`;
}

export default Footer;